import { useContext, useEffect, useState } from 'react'

import { callApiNew } from 'api/axios'
import { formatTogetherCommunity } from 'api/dataTransform'
import { PATHS } from 'api/paths'
import { TogetherCommunity } from 'interfaces/types'
import { AppContext } from 'state/appContext'

export const useEmbeddedCommunity = ({
  communityId,
}: {
  communityId?: number
}) => {
  const {
    state: { isLoggedIn },
  } = useContext(AppContext)

  const [community, setCommunity] = useState<TogetherCommunity>()
  useEffect(() => {
    ;(async () => {
      if (isLoggedIn && communityId) {
        const response = await callApiNew(
          PATHS.TOGETHER.GET_TOGETHER_COMMUNITY_DETAIL,
          {
            params: {
              communityId: communityId,
              // dueDateMonth: dayjs(dueDate).get('month') + 1,
              // dueDateYear: dayjs(dueDate).get('y'),
              showHidden: 1,
            },
          },
          'together',
        )
        const totalCommunity = formatTogetherCommunity(response?.data)
        setCommunity(totalCommunity)
      }
    })()
  }, [communityId, isLoggedIn])
  useEffect(() => {
    ;(async () => {
      if (isLoggedIn && community && !community.joined) {
        await callApiNew(
          PATHS.TOGETHER.POST_TOGETHER_JOIN_COMMUNITY,
          {
            method: 'POST',
            data: {
              ids: [community?.id],
            },
          },
          'together',
        )
        setCommunity((p) => ({ ...p, joined: true } as TogetherCommunity))
      }
    })()
  }, [isLoggedIn, community?.joined])

  return { community }
}
